module.exports = __webpack_public_path__ + "img/ss_ye_00a.6d159bc1.jpg";